/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const NotAllowedIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="NotAllowedIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM13 8C13 10.7614 10.7614 13 8 13C6.79937 13 5.69757 12.5768 4.83563 11.8715L11.8715 4.83563C12.5768 5.69757 13 6.79937 13 8ZM4.12853 11.1644L11.1644 4.12853C10.3024 3.42318 9.20063 3 8 3C5.23858 3 3 5.23858 3 8C3 9.20063 3.42318 10.3024 4.12853 11.1644Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

NotAllowedIcon.tags = [
  'prohibition',
  'ban',
  'forbidden',
  'restriction',
  'block',
];

NotAllowedIcon.category = 'Style Panel';

NotAllowedIcon.iconSize = 16;
